import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { UserDTO } from '../interfaces/user.interface';
import { UsersService } from '../services/users.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AddUserComponent } from './components/add-user/add-user.component';
import { AuthService } from '../../authentication/service/auth.service';
import { MatSelectChange } from '@angular/material/select';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],
})
export class UsersComponent implements OnInit {
  public users$: Observable<Array<UserDTO>>;
  public viewBtnPermission: boolean;
  public selectedValue = 1;
  filterState = [
    { value: 1, viewValue: 'Habilitados' },
    { value: 0, viewValue: 'Deshabilitados' }
  ];

  constructor(
    private userService: UsersService,
    private dialog: MatDialog,
    private authService: AuthService
  ) {
    this.users$ = new Observable<Array<UserDTO>>();
  }

  ngOnInit(): void {
    this.getUsers();
    this.viewBtnPermission = this.authService.ValidateUserPermission(
      'ViewBtnSocios'
    );
  }s

  getUsers() {
    this.users$ = this.userService.getUsers(true);
  }

  postUser() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.panelClass = 'modalAddUsers';
    const dialogRef = this.dialog.open(AddUserComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((res: boolean) => {
      if (res) this.getUsers();
    });
  }

  reciveNotify(mensaje: any) {
    if(this.selectedValue == 1) {
      this.users$ = this.userService.getUsers(true);
    }
    else {
      this.users$ = this.userService.getUsers(false);
    }
  }

  onFilterChange(event: MatSelectChange): void {
    this.selectedValue = event.value;
    if(this.selectedValue == 1) {
      this.users$ = this.userService.getUsers(true);
    }
    else {
      this.users$ = this.userService.getUsers(false);
    }
  }

}
